import React, { useEffect, useState, useCallback } from "react";
import { Button, Form, Nav, Offcanvas, Row, Tab } from "react-bootstrap";
import Select from "react-select";
import Images from "../../Helpers/Images";
import { Link } from "react-router-dom";
import { BiFilter } from "react-icons/bi";
import Sidebar from "./Sidebar";
import Header from "../../Components/comman/Header";
import MobileHeader from "../../Components/comman/MobileHeader";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";
import Aos from "aos";
import { FaSearch } from "react-icons/fa";
import { debounce } from "lodash";

const Campaign = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [filters, setFilters] = useState({
    search: "",
    sort_by: "",
    status: "",
  });

  const options = [
    { value: "pending", label: "Pending" },
    { value: "activated", label: "Activated" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const optionsSort = [
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f4f4f8",
      fontWeight: "bold",
    }),
    option: (provided, state) => ({
      ...provided,
      fontWeight: "bold",
      backgroundColor: state.isSelected ? "#afd7d1" : "#f4f4f8",
      color: state.isSelected ? "#000000" : "#575757",
      borderBottom: "1px solid #ccc",
      "&:last-child": {
        borderBottom: "none",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontWeight: "bold",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#bdbdbd",
    }),
    input: (provided) => ({
      ...provided,
      fontWeight: "bold",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#afd7d1" : "#dee2e6",
      boxShadow: state.isFocused ? "none" : "none",
      "&:hover": {
        borderColor: "none",
      },
    }),
  };

  const debouncedSearch = useCallback(
    debounce((searchValue) => {
      setFilters((prev) => ({ ...prev, search: searchValue }));
    }, 500),
    []
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedSearch(value);
  };

  const handleClear = () => {
    setInputValue("");
    setFilters((prev) => ({ ...prev, search: "" }));
  };

  const handleStatusChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      status: selectedOption?.value || "",
    }));
  };

  const handleSortChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      sort_by: selectedOption?.value || "",
    }));
  };

  const clearAllFilters = () => {
    setInputValue("");
    setFilters({
      search: "",
      sort_by: "",
      status: "",
    });
  };

  const getCampaigns = () => {
    let config = {
      url: ApiUrl.getCamapignsByFilter,
      method: "POST",
      body: {
        search: filters.search,
        sort_by: filters.sort_by,
        status: filters.status,
      },
    };

    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        setIsLoading(false);
        const data = res?.data || {};
        setCampaigns(data.data || []);
      },
      (err) => {
        console.log("error", err);
        setIsLoading(false);
        setCampaigns([]);
      }
    );
  };

  useEffect(() => {
    getCampaigns(1);
  }, [filters.search, filters.sort_by, filters.status]);

  useEffect(() => {
    Aos.init({});
    getCampaigns();
  }, []);

  return (
    <div className="main-pages-wrapper">
      <Header />
      <MobileHeader />
      <CustomLoader visible={isLoading} />
      <div className="my-campaign-main-wrapper">
        <Tab.Container activeKey={`campaigns`}>
          <Sidebar />
          <div className="campagin-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"campaigns"}>
                <h6 className="heading-title">My Campaigns</h6>
                <Tab.Container defaultActiveKey="opt-ins">
                  <Row className="mycampagin-wrap">
                    <Nav variant="tabs" className="flex-row">
                      <Nav.Item className="sidebar-list-item">
                        <Nav.Link eventKey="opt-ins">Opt-Ins</Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="sidebar-list-item">
                        <Nav.Link eventKey="invites">Invites</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="opt-ins">
                        <div className="filter-part">
                          <div className="searchBar-filter">
                            <input
                              type="text"
                              placeholder="Search campaigns..."
                              value={inputValue}
                              onChange={handleSearch}
                              className="searchbar-input"
                            />
                            {inputValue && (
                              <button
                                onClick={handleClear}
                                className="searchbar-clear"
                              >
                                ×
                              </button>
                            )}
                            <span className="searchbar-icon">
                              <FaSearch />
                            </span>
                          </div>

                          <div className="status-wrap">
                            <Select
                              placeholder="Status"
                              options={options}
                              styles={customStyles}
                              value={
                                filters.status
                                  ? options.find(
                                      (opt) => opt.value === filters.status
                                    )
                                  : null
                              }
                              onChange={handleStatusChange}
                              isClearable={true}
                            />
                          </div>

                          <div className="sort-wrap">
                            <Select
                              placeholder="Sort"
                              options={optionsSort}
                              styles={customStyles}
                              value={
                                filters.sort_by
                                  ? optionsSort.find(
                                      (opt) => opt.value === filters.sort_by
                                    )
                                  : null
                              }
                              onChange={handleSortChange}
                              isClearable={true}
                            />
                          </div>

                          {(filters.search ||
                            filters.status ||
                            filters.sort_by) && (
                            <button
                              onClick={clearAllFilters}
                              className="clear-filters-btn"
                            >
                              Clear Filters
                            </button>
                          )}
                        </div>

                        {campaigns.length > 0 ? (
                          <div className="influencerCampaignWrapper">
                            {campaigns.map((campaign, index) => (
                              <div
                                className="myCampaign-box"
                                data-aos="fade-up"
                                data-aos-duration="2000"
                                key={`campaignItem${index}`}
                              >
                                <Link
                                  to="/campagin-detail"
                                  state={{
                                    product: campaign,
                                    from: "InfluencerCampaign",
                                  }}
                                  className="campaign-box-inner"
                                >
                                  <div className="campaign-product-box-img">
                                    <img
                                      src={campaign?.campaign_logo_url}
                                      alt="product-img"
                                    />
                                  </div>
                                  <div className="campaign-content">
                                    <div className="heading">
                                      <h6 className="product-name">
                                        {campaign?.brand?.company_name}
                                      </h6>
                                      <p className="p-title">
                                        {campaign?.campaign_title}
                                      </p>
                                    </div>
                                    <div className="social-platform-box-w-wrapper">
                                      <div className="social-Platform-w">
                                        <p>Platforms</p>
                                        <span>
                                          {campaign?.campaign_platform?.map(
                                            (platform, index) => (
                                              <img
                                                key={index}
                                                src={
                                                  platform?.logo
                                                    ? platform.logo
                                                    : "/default-platform.png"
                                                }
                                                alt={platform?.name}
                                                style={{
                                                  width: "22px",
                                                  height: "22px",
                                                  objectFit: "contain",
                                                  marginRight: 5,
                                                }}
                                              />
                                            )
                                          )}
                                        </span>
                                      </div>
                                      <div className="list-name">
                                        <span>Residence</span>
                                        {campaign?.countries?.map(
                                          (country, index) => (
                                            <img
                                              className="countryFlag"
                                              key={index}
                                              src={
                                                country?.flag_url
                                                  ? country.flag_url
                                                  : "/default-platform.png"
                                              }
                                            />
                                          )
                                        )}
                                      </div>
                                    </div>
                                    <div className="list-wrapper">
                                      <div className="list-name">
                                        <span>Followers</span>
                                        <span className="title">
                                          {" "}
                                          {
                                            campaign?.campaign_platform[0]
                                              ?.social_engagement_data?.follower
                                          }
                                          +
                                        </span>
                                      </div>
                                      <div className="list-name">
                                        <span>Engagement</span>
                                        <span className="title">
                                          {
                                            campaign?.campaign_platform[0]
                                              ?.social_engagement_data
                                              ?.engagement
                                          }
                                          % +
                                        </span>
                                      </div>
                                      <div className="list-name">
                                        <span>Age</span>
                                        <span className="title">
                                          {" "}
                                          {campaign?.age?.min}-
                                          {campaign?.age?.max}+
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="content-area">
                            <img src={Images.noAccount} alt="no acoount" />
                            <p>
                              {filters.search
                                ? `No campaigns found related to "${filters.search}". Try different keywords or clear your search.`
                                : filters.status || filters.sort_by
                                ? "No campaigns found with the selected filters."
                                : "You haven't opted in to any campaigns yet."}
                            </p>
                            {(filters.search ||
                              filters.status ||
                              filters.sort_by) && (
                              <button
                                onClick={clearAllFilters}
                                className="theme-btn clearBtn"
                                style={{ marginTop: "10px" }}
                              >
                                Clear Filters
                              </button>
                            )}
                            {!filters.search &&
                              !filters.status &&
                              !filters.sort_by && (
                                <Link
                                  to="/collaboration-hub"
                                  className="theme-btn"
                                >
                                  Explore Campaigns
                                </Link>
                              )}
                          </div>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey="invites">
                        <div className="invite-content-wrapper">
                          <img src={Images.noAccount} alt="no-account" />
                          <p>You have no collaboration invites.</p>
                          <Link to="/collaboration-hub" className="theme-btn">
                            Explore Campaigns
                          </Link>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Row>
                </Tab.Container>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default Campaign;
